angular.module('shared').directive('numericBinding', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      model: '=ngModel'
    },
    link: function(scope) {
      return scope.$watch('model', function() {
        if (scope.model) {
          return scope.model = parseFloat(scope.model);
        }
      });
    }
  };
}]);
